// @flow
import React from 'react'
import './styles.scss'
import { number } from 'prop-types'

type Props = {
  slideId: string,
  slideIndex: number,
  activeSlide: number,
  isMobile: boolean,
  imgMobile: string,
  imgDesktop: string,
  imgOverlay: string,
  captionOpen: boolean,
  captionWasOpen: boolean,
  isSliding: string,
  caption: string,
  credits: string,
  toggleCaption: any
}

export class StaticSlide extends React.Component<Props, State> {
  render() {
    return (
      <>
        <div
          className='section comic-slide'
          id={this.props.slideId}
          style={{
            backgroundImage: `url(${
              this.props.isMobile ? this.props.imgMobile : this.props.imgDesktop
              })`
          }}
        >
        </div>
      </>
    )
  }
}
